import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { ActivityStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-activity-status-container',
  templateUrl: './activity-status-container.component.html',
  styleUrls: ['./activity-status-container.component.scss']
})
export class ActivityStatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  activitystatuss$: Observable<ActivityStatusDto[]>;
  loading: boolean;
  isLoadingActivityStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingActivityStatus$ = this.gatwayFacade.isLoadingGateway("ActivityStatus");
    this.activitystatuss$ = this.gatwayFacade.loadGateway("ActivityStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteActivityStatus(deletedValue: any) {
    this.gatwayFacade.remove("ActivityStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitActivityStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.ActivityStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllActivityStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllActivityStatus.push(pullData[i]);
    }
  }

// check if the addAllActivityStatus array is not empty, then dispatch the data to the store
   if(addAllActivityStatus.length > 0) {
    this.gatwayFacade.add('ActivityStatus', addAllActivityStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('ActivityStatus', allUpdates, ['id']);
  }

   }


}
